module.exports = "/virtual-football-league/img/amblems/right/logos/Leicester.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/Leicester.png
// module id = 2208
// module chunks = 4